<template>
  <div class="text-sm">
    <p class="mt-6"><b>2026.02.13</b> - Temple gold slider</p>
    <div class="ml-5 pb-4 text-yellow-400">
      <div class="font-bold mt-2">QoL</div>
      <ul class="ml-4 list-disc">
        <li>
          Temple gold sacrifice slider now caps at the maximum effective amount instead of letting
          you overspend
        </li>
      </ul>

      <div class="font-bold mt-2">Performance</div>
      <ul class="ml-4 list-disc">
        <li>
          Fixed memory leaks from improper cleanup of visual objects, especially in the Caverns
        </li>
      </ul>
    </div>
  </div>
</template>
